import script from "./DeclarationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeclarationForm.vue?vue&type=script&setup=true&lang=js"

import "./DeclarationForm.vue?vue&type=style&index=0&id=509a0a22&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509a0a22"]])

export default __exports__